<template>
  <Content id="institutions">
    <div slot="search">
      <Form :label-width="100" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="机构名称" :label-width="70"><Input v-model="search.name"/></FormItem></Col>
          <Col><FormItem label="子机构名称" :label-width="90"><Input v-model="search.subordinate"/></FormItem></Col>
          <Col><FormItem label="前缀" :label-width="50"><Input v-model="search.labels" maxlength="3"/></FormItem></Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center','height':'40px'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="id" label="机构id" min-width="50"/>
      <el-table-column fixed align="center" prop="name" label="机构名称" min-width="150"/>
      <el-table-column fixed align="center" prop="subordinate" label="子机构名称" min-width="120"/>
      <el-table-column align="center" prop="labels" label="前缀" min-width="45"/>
      <el-table-column align="center" prop="status" label="状态" min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="creator" label="创建人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.creatorAccount }}</div>
          <div>{{ row.creator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" min-width="160"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="最后操作时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="80" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>&nbsp;&nbsp;
          <!--
          <el-popover placement="top" min-width="150" v-model="deleteVisible['visible_' + row.id]">
            <p style="display: flex; -webkit-box-align: center; align-items: center; line-height: 35px; font-size: 16px; ">
              <i class="el-popconfirm__icon el-icon-info" style="color: red;"/>是否确定删除？
            </p>
            <div style="text-align: right; margin: 0;line-height: 30px;">
              <el-button size="small" type="text" @click="cancel(row)" style="padding: 7px 15px;font-size: 12px;border-radius: 3px;background: #FFFFFF;border: 1px solid #DCDFE6;color: #606266;">取消</el-button>
              <el-button type="primary" size="small" @click="handleRemove(row)">确定</el-button>
            </div>
            <a slot="reference" style="color: #409EFF;">删除</a>
          </el-popover>
          -->
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal ref="modalRef" v-model="editWindow" width="40%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <InstitutionEdit ref="edit"  @on-submit="handleSubmit" />
      <div slot="footer">
        <Button type="primary" @click="submit">确定</Button>
        <Button @click="editWindow = false">取消</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {
  _delInstitution,
  _getInstitutionList,
  _updateStatus
} from "@/services/manage/institutions";
import InstitutionEdit from "./InstitutionEdit";
export default {
  name: "Institutions",
  components: {
    InstitutionEdit
  },
  data() {
    return {
      search: {
        name: "",
        subordinate: "",
        labels: "",
      },
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      currentRowIndex: null,
      deleteVisible:{},
      windowTitle:"新增",
      editWindow:false,
      tableHeight: 0,
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 250}px`;
    },
    query(){
      if (this.search.labels && this.search.labels.match(/[^\d]+/g)){
        this.$message.warning("标识只能为数字")
        return;
      }
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      if (this.search.labels && this.search.labels.match(/[^\d]+/g)){
        this.$message.warning("标识只能为数字")
        return;
      }

      this.search.name = this.search.name.trim();
      this.search.labels = this.search.labels.trim();
      _getInstitutionList({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          if (res.errcode === 1 && res.data && res.data.records && res.data.records.length > 0) {
            res.data.records.forEach(item => {
              this.deleteVisible['visible_' + item.id] = false;
            })
          }

          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    handleCreate() {
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    cancel(){
      this.$nextTick(()=>{
        document.getElementById('elPopoverVisible').click();
      })
    },
    handleRemove(row) {
      _delInstitution({id: row.id}).then(res => {
        if (res.errcode == 1){
          this.$message.success("删除成功")
          this.handleDataList();
        } else{
          this.$message.error(res.errmsg);
        }
      })
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
</style>

